/**
  All of the routes for the Material Kit 2 React React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

// @mui material components
import React from "react";
import navbarRoutes from "navbar.routes";

// Pages
const AboutUsLayout = React.lazy(() => import("layouts/pages/landing-pages/AboutUs"));
const SpecialtyPageLayout = React.lazy(() => import("layouts/pages/landing-pages/SpecialtyPage"));
const SuccessCasesLayout = React.lazy(() => import("layouts/pages/landing-pages/SuccessCases"));
const ContactUsLayout = React.lazy(() => import("layouts/pages/landing-pages/ContactUs"));
const PrivacyPolicyLayout = React.lazy(() => import("layouts/pages/landing-pages/PrivacyPolicy"));
const SpecialOffersPageLayout = React.lazy(() =>
  import("layouts/pages/landing-pages/SpecialOffers")
);
const FeedbackLayout = React.lazy(() => import("layouts/pages/landing-pages/Feedback"));
const CaptivePortalPageLayout = React.lazy(() =>
  import("layouts/pages/landing-pages/CaptivePortal")
);

// This maps a route path to its corresponding lazy-loaded component.
const routeComponentMap = {
  "/acerca-de-nosotros": <AboutUsLayout />,
  "/especialidades": <SpecialtyPageLayout />,
  "/casos-de-exito": <SuccessCasesLayout />,
  "/contacto": <ContactUsLayout />,
  "/aviso-de-privacidad": <PrivacyPolicyLayout />,
  "/opinion": <FeedbackLayout />,
  "/promociones": <SpecialOffersPageLayout />,
  "/bienvenido": <CaptivePortalPageLayout />,
};

// Combine navbar routes with their components
const routes = navbarRoutes.map((route) => ({
  ...route,
  component: routeComponentMap[route.route],
}));

// Add routes that are not in the navbar but are accessible
routes.push(
  {
    route: "/aviso-de-privacidad",
    component: routeComponentMap["/aviso-de-privacidad"],
  },
  {
    route: "/opinion",
    component: routeComponentMap["/opinion"],
  },
  {
    route: "/bienvenido",
    component: routeComponentMap["/bienvenido"],
  }
);

export default routes;
